// mobile menu
jQuery(function(){
    $('#navburger').click(function(){
        $('.nav-mobile').toggle();
    });
    $('.nav-mobile .close').click(function(){
        $('.nav-mobile').toggle();
    });
    $('.icon-arrow_forward.bg-gold').click(function(){
        $(this).next().toggle();
    });
});

// slick
jQuery(function() { 
    if($('.home-carousel')[0]){
        $('.home-carousel').slick({
            dots: true,
            arrows: false
        });
    } 
    
    if($('.product-images')[0]){
        $('.product-images').slick({
            dots: true,
            arrows: false
        });
    } 
});

// tabs
const tabs = document.querySelectorAll('.tabs.cycle li');
const tabContentDivs = document.querySelectorAll('.tabbedSection');

function tabChange(){
    tabSelect = document.getElementById('tabsSelect').value;
    displayTab(tabSelect);
}

tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
        tabs.forEach(item => item.classList.remove('is-active'));
        tab.classList.add('is-active');

        let target = tab.dataset.target;
        displayTab(target);
    });
});

function displayTab(tabTarget){
    tabContentDivs.forEach(div => {
        if(div.getAttribute('id') === tabTarget){
            div.classList.remove('is-hidden');
        } else{
            div.classList.add('is-hidden');
        }
    });
}

// vertical tabs
const verticalTabs = document.querySelectorAll('.vertical-tabs-list li');
const verticalTabContentDivs = document.querySelectorAll('.vertical-tab-content');

verticalTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
        verticalTabs.forEach(item => item.classList.remove('is-active'));
        tab.classList.add('is-active');

        let target = tab.dataset.target;
        displayVerticalTab(target);
    });
});

function displayVerticalTab(tabTarget){
    verticalTabContentDivs.forEach(div => {
        if(div.getAttribute('id') === tabTarget){
            div.classList.remove('is-hidden');
        } else{
            div.classList.add('is-hidden');
        }
    });
}

// messages/faqs
const messageHeaders = document.querySelectorAll('.messages .message .message-header');
const messageBodies = document.querySelectorAll('.messages .message .message-body');

messageHeaders.forEach((messageHeader) => {
    messageHeader.addEventListener('click', () => {
        let hideBody = messageHeader.nextElementSibling.classList.contains('is-active');
        messageBodies.forEach(messageBody => messageBody.classList.remove('is-active'));
        if(!hideBody)
            messageHeader.nextElementSibling.classList.add('is-active');
    })
});
    
// in-page nav
function targetChange(){
    targetId = document.getElementById('inPageSelect').value;
    document.getElementById(targetId).scrollIntoView({
        behavior: 'smooth'
      });
}